import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const HeroImageWrapper = styled.div`
  max-width: 65vw;
  margin: auto;
  @media (max-width: 1150px) {
    max-width: 100%;
  }
`;

export const HeroImage = styled.img`
  object-fit: cover;
  width: 100%;
  max-height: 500px;
`;
